import './work.css';
import { useState } from "react";
import { ReactComponent as IconFinger } from './icons/finger.svg';
import { ReactComponent as IconSymfony } from '../skills/icons/symfony.svg';
import { ReactComponent as IconMailjet } from '../skills/icons/mailjet.svg';
import { ReactComponent as IconStripe } from '../skills/icons/stripe.svg';
import { ReactComponent as Iconbootstrap } from '../skills/icons/bootstrap.svg';
import { ReactComponent as IconTalend } from '../skills/icons/talend.svg';
import { ReactComponent as IconDocker } from '../skills/icons/docker.svg';
import { ReactComponent as IconApiPlatform } from '../skills/icons/apiPlatform.svg';
import { ReactComponent as IconNode } from '../skills/icons/node.svg';
import { ReactComponent as IconSocket } from '../skills/icons/socket.svg';
import { ReactComponent as IconReact } from '../skills/icons/react.svg';
import { ReactComponent as IconMaterial } from '../skills/icons/material.svg';
import { ReactComponent as IconRabbit } from '../skills/icons/rabbitmq.svg';
import { ReactComponent as IconFirebase } from '../skills/icons/firebase.svg';

import {
    Container, Row, Col, Button
} from 'reactstrap';

const Work = () => {
    const [hidden, setHidden] = useState(true);
    const [hidden1, setHidden1] = useState(true);
    const [hidden2, setHidden2] = useState(true);
    const [hidden3, setHidden3] = useState(true);
    return (
        <Container className='work-container' id='portefolio'>
            <h3 className='title'>MES REALISATIONS</h3>
            <Row className='work-row'>
                <Col lg={6} className=''>
                    <div className='work-bloc'>
                        <h6 className='work-bloc-title'>SITE ECOMMERCE</h6>
                        <div className='' style={{ height: '200px' }}>
                            <div className='project-desc'>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Authentification - Dashboard admin</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Produits - Panier</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Commande - Paiement</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Emails - IA(génération automatique de description de produit) </span></p>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col lg={6} className=''>
                    <div className='work-bloc'>
                        <h6 className='work-bloc-title'>EXPORT DE DONNEES</h6>
                        <div className='' style={{ height: '200px' }}>
                            <div className='project-desc'>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Authentification</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Démande d'export</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>API</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>ETL</span></p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className='work-row'>
                <Col lg={6} className=''>
                    <div className='work-bloc'>
                        <h6 className='work-bloc-title'>NOTIFICATION / WIDGET</h6>
                        <div className='' style={{ height: '200px' }}>
                            <div className='project-desc'>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Gestion de clients</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Envoie de notification</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Reception de notification</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Consommation de message</span></p>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col lg={6} className=''>
                    <div className='work-bloc'>
                        <h6 className='work-bloc-title'>PORTEFOLIO</h6>
                        <div className='' style={{ height: '200px' }}>
                            <div className='project-desc'>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Portefolio</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Blog</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>CV</span></p>
                                <p className='desc-fonct'><IconFinger height={25} /> <span>Contact</span></p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Work;